module.exports = "<div class=\"listHeader\" id=\"<%= id %>\">\n\t\t<%= text.toUpperCase() %>\n\t</div>"